"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constants = require("../../constants/constants");
var _contexts = require("../../contexts");
var _Icon = _interopRequireDefault(require("../icons/Icon"));
var _iconUtils = require("../icons/iconUtils");
var _actions = require("../../contexts/actions");
var _reactIntl = require("react-intl");
var _paymentMethodMessages = require("./paymentMethodMessages");
require("../../style/paymentAccordion/main.css");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var PAYMENT_METHODS_WITH_PREVIEW_TEXT = [_constants.PAYMENT_METHOD_ALIAS.ZIP_PAY];
var PaymentAccordion = function PaymentAccordion(_ref) {
  var paymentMethods = _ref.paymentMethods,
    customFunctions = _ref.customFunctions;
  var _useContext = (0, _react.useContext)(_contexts.PaymentContext),
    paymentDispatch = _useContext.dispatch,
    _useContext$state = _useContext.state,
    activePaymentMethods = _useContext$state.activePaymentMethods,
    cartAmount = _useContext$state.cartAmount;
  var _useContext2 = (0, _react.useContext)(_contexts.AdyenContext),
    numberOfPaymentMethods = _useContext2.state.numberOfPaymentMethods;
  var _useState = (0, _react.useState)({
      name: null,
      index: -1,
      disabled: false
    }),
    _useState2 = _slicedToArray(_useState, 2),
    _selectedPaymentMethod = _useState2[0],
    setSelectedPaymentMethod = _useState2[1];
  var _useIntl = (0, _reactIntl.useIntl)(),
    formatMessage = _useIntl.formatMessage;
  var handlePaymentMethodSelection = function handlePaymentMethodSelection(data) {
    var onPaymentMethodChangeCallback = function onPaymentMethodChangeCallback(paymentMethod) {
      if (customFunctions['onPaymentMethodChange']) {
        if (paymentMethod != _constants.PAYMENT_METHOD_ALIAS.ADYEN_DROPIN) {
          customFunctions['onPaymentMethodChange']({
            paymentMethod: paymentMethod
          });
        }
      }
    };

    // This is an important edge case to handle the first disabled payment method.
    // We have to select the next available payment method, because if the first payment method is itself disabled,
    // accessibility selection using the keyboard will not be possible.

    if (data.index === 0 && data.disabled) {
      if (activePaymentMethods.length > 1) {
        setSelectedPaymentMethod({
          name: activePaymentMethods[1],
          index: 1,
          disabled: false
        });
        onPaymentMethodChangeCallback(activePaymentMethods[1]);
        return;
      }
    }
    if (_selectedPaymentMethod.name != data.name) {
      onPaymentMethodChangeCallback(data.name);
      setSelectedPaymentMethod(data);
    }
  };
  (0, _react.useEffect)(function () {
    if (cartAmount == 0) {
      if (activePaymentMethods.includes(_constants.PAYMENT_METHOD_ALIAS.ADYEN_DROPIN)) {
        setSelectedPaymentMethod({
          name: _constants.PAYMENT_METHOD_ALIAS.ADYEN_DROPIN,
          index: activePaymentMethods.length - 1
        });
      } else if (activePaymentMethods.includes(_constants.PAYMENT_METHOD_ALIAS.CREDIT_CARD)) {
        setSelectedPaymentMethod({
          name: _constants.PAYMENT_METHOD_ALIAS.CREDIT_CARD,
          index: activePaymentMethods.length - 1
        });
      }
    } else {
      setSelectedPaymentMethod({
        name: null,
        index: -1
      });
    }
  }, [activePaymentMethods, cartAmount]);
  (0, _react.useEffect)(function () {
    paymentDispatch((0, _actions.updateSelectedPaymentMethod)(_selectedPaymentMethod.name));
  }, [_selectedPaymentMethod, cartAmount]);
  return /*#__PURE__*/_react.default.createElement("fieldset", {
    className: "payment-accordion",
    id: "payment-accordion"
  }, paymentMethods === null || paymentMethods === void 0 ? void 0 : paymentMethods.map(function (paymentMethod, index) {
    var paymentSelected = _selectedPaymentMethod.name === paymentMethod.key;
    var isAdyenDropin = paymentMethod.key === _constants.PAYMENT_METHOD_ALIAS.ADYEN_DROPIN;
    var isCreditCard = paymentMethod.key === _constants.PAYMENT_METHOD_ALIAS.CREDIT_CARD;
    var isZip = paymentMethod.key === _constants.PAYMENT_METHOD_ALIAS.ZIP_PAY;
    var isDisabled = cartAmount == 0 && !(isAdyenDropin || isCreditCard) || cartAmount < 35 && isZip;
    if (!_selectedPaymentMethod.name && index == 0) {
      handlePaymentMethodSelection({
        name: paymentMethod.key,
        index: index,
        disabled: isDisabled
      });
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: 'payment-checkout__payment-method ' + (paymentSelected ? 'payment-checkout__payment-method--selected ' : '') + (_selectedPaymentMethod.index == index - 1 ? 'payment-checkout__payment-method--previous-selected ' : '') + (_selectedPaymentMethod.index == index + 1 ? 'payment-checkout__payment-method--next-selected' : '') + (isDisabled ? ' payment-method-disable' : ''),
      key: paymentMethod.key,
      id: 'payment-checkout__payment-method__' + paymentMethod.key,
      onClick: function onClick() {
        return handlePaymentMethodSelection({
          name: paymentMethod.key,
          index: index,
          disabled: isDisabled
        });
      }
    },
    /*#__PURE__*/
    /**If the Adyen dropin is selcted we will disable the headers for it 
     * as it causes a bit of confusion
    */
    _react.default.createElement("div", {
      className: paymentSelected && isAdyenDropin ? 'payment-checkout__payment-method-header--hidden' : 'payment-checkout__payment-method-header'
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "payment-checkout__payment-method-header__title",
      id: paymentMethod.key + '-header'
    }, /*#__PURE__*/_react.default.createElement("input", {
      className: 'payment-checkout__payment-method__radio ' + (paymentSelected && isAdyenDropin ? 'payment-checkout__payment-method__radio--hidden' : ''),
      checked: paymentSelected,
      onChange: function onChange() {},
      id: paymentMethod.key,
      value: isAdyenDropin && numberOfPaymentMethods == 1 ? formatMessage(_paymentMethodMessages.paymentMethodLabels['ADYEN_DROPIN_SINGLE_PAYMENT_METHOD']) : formatMessage(_paymentMethodMessages.paymentMethodLabels[paymentMethod.key]),
      name: "paymentMethodOption",
      disabled: isDisabled,
      type: "radio"
    }), /*#__PURE__*/_react.default.createElement(_Icon.default, {
      icon: (0, _iconUtils.getPaymentMethodIconSource)(paymentMethod.key),
      className: (0, _iconUtils.getIconWrapperClassName)(paymentMethod.key)
    }), /*#__PURE__*/_react.default.createElement("label", {
      className: 'payment-checkout__payment-method__name ' + (paymentSelected ? 'payment-checkout__payment-method__name--selected' : ''),
      htmlFor: paymentMethod.key
    }, isAdyenDropin && numberOfPaymentMethods == 1 ? formatMessage(_paymentMethodMessages.paymentMethodLabels['ADYEN_DROPIN_SINGLE_PAYMENT_METHOD']) : formatMessage(_paymentMethodMessages.paymentMethodLabels[paymentMethod.key])))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
      className: 'payment-checkout__payment-method-content ' + (paymentSelected ? 'payment-checkout__payment-method-content--selected' : '')
    }, paymentMethod), isDisabled && PAYMENT_METHODS_WITH_PREVIEW_TEXT.includes(paymentMethod.key) && /*#__PURE__*/_react.default.createElement("div", {
      className: "payment-checkout__payment-method__preview-message"
    }, formatMessage(_paymentMethodMessages.previewMessages[paymentMethod.key]))));
  }));
};
PaymentAccordion.propTypes = {
  paymentMethods: _propTypes.default.array,
  customFunctions: _propTypes.default.object
};
var _default = PaymentAccordion;
exports.default = _default;